export default "__VITE_ASSET__4af8d257__"